/**
 * POST-only Shopify endpoints (/contact, /cart/add) return 404/400 on crawler GET.
 * Forms expose a same-page action for audits; real submits go to data-kezvion-post-endpoint.
 */
function initKezvionFormEndpoints() {
  document.querySelectorAll('form[data-kezvion-post-endpoint]').forEach((form) => {
    if (form.dataset.kezvionEndpointBound === '1') return;
    form.dataset.kezvionEndpointBound = '1';

    form.addEventListener('submit', async (event) => {
      const endpoint = form.getAttribute('data-kezvion-post-endpoint');
      if (!endpoint) return;

      const action = form.getAttribute('action') || '';
      if (action === endpoint || action.endsWith(endpoint)) return;

      event.preventDefault();

      const submitter = event.submitter;
      if (submitter instanceof HTMLButtonElement) submitter.disabled = true;

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          body: new FormData(form),
          credentials: 'same-origin',
          redirect: 'follow',
        });

        if (response.ok || response.redirected) {
          form.dispatchEvent(new CustomEvent('kezvion:form-posted', { bubbles: true }));
          if (form.classList.contains('email-signup__form')) {
            const success = form.querySelector('[data-kezvion-newsletter-success]');
            if (success) {
              success.hidden = false;
              success.focus?.();
            }
            form.reset();
          } else if (form.classList.contains('kz-promo__form')) {
            form.reset();
          } else if (form.classList.contains('contact-form__form')) {
            window.location.reload();
          }
        } else {
          form.dispatchEvent(
            new CustomEvent('kezvion:form-error', { bubbles: true, detail: { status: response.status } })
          );
        }
      } catch (error) {
        console.warn('[kezvion-form-endpoints]', error);
        form.dispatchEvent(new CustomEvent('kezvion:form-error', { bubbles: true }));
      } finally {
        if (submitter instanceof HTMLButtonElement) submitter.disabled = false;
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initKezvionFormEndpoints);
} else {
  initKezvionFormEndpoints();
}

document.addEventListener('shopify:section:load', initKezvionFormEndpoints);
